import { Box, buildPath, buildTemplatePath, Page, PageRoute, Stack, Typography } from "@compass/core";
import { Select } from "components";
import { DashboardReport, PowerBi } from "generated/openApi";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";

const routeName = "dashboardReport";

export const dashboardReportPageRoute: PageRoute = {
  handle: "Dashboard",
  templatePath: buildTemplatePath(routeName),
  getPath: () => buildPath(routeName),
};

export const DashboardReportPage = () => {
  const [dashboardReport, setDashboardReport] = useState<DashboardReport>({});
  const [selectedPowerBi, setSelectedPowerBi] = useState<PowerBi>();

  useEffect(() => {
    ApiService.dashboardReport.get().then((response) => {
      setDashboardReport(response);
      setSelectedPowerBi(response.powerBis?.[0]);
    });
  }, []);

  const getReportUrl = (powerBi: PowerBi | undefined) => {
    if (powerBi) {
      return `https://app.powerbi.com/view?r=${powerBi.urlPostfix}`;
    }
  };

  return (
    <Page
      header={
        <Stack direction="row" justifyContent="space-between">
          <Stack flexGrow={1}>
            <Typography variant="inherit">{dashboardReportPageRoute.handle}</Typography>
          </Stack>

          <Stack direction="row" alignItems="center" spacing="sm" flexGrow={1}>
            <Select
              size="small"
              value={selectedPowerBi}
              options={dashboardReport.powerBis}
              getOptionLabel={(option) => option.name}
              onChange={(e, value) => setSelectedPowerBi(value)}
            />
          </Stack>
        </Stack>
      }
    >
      <iframe
        width="100%"
        height="100%"
        src={getReportUrl(selectedPowerBi)}
        style={{ border: "none" }}
        allowFullScreen={true}
      ></iframe>
    </Page>
  );
};
